import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface MdsLockTooltipProps {
  locked: boolean;
  children: React.ReactElement;
}

/**
 * Explains why an MDS-owned field is disabled while MDS is unavailable.
 * The wrapper is focusable so the tooltip also opens on keyboard focus;
 * a natively disabled input cannot receive focus.
 */
const MdsLockTooltip = ({ locked, children }: MdsLockTooltipProps) => {
  const { t } = useTranslation();

  if (!locked) return children;

  // Typed explicitly: used inline as a ReactNode prop, `t` is inferred as
  // possibly undefined under the typings CI installs, which fails the build.
  const message = t('restaurant.info.edit.mdsUnavailableTooltip') as string;

  return (
    <Tooltip title={message}>
      <div tabIndex={0} style={{ width: '100%' }}>
        {children}
      </div>
    </Tooltip>
  );
};

export default MdsLockTooltip;
